// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".districts-block[data-v-52df91b0]{height:85vh;overflow-y:scroll;padding-bottom:100px}@media(min-width:992px){.districts-block[data-v-52df91b0]{display:flex;flex-wrap:wrap;height:auto;margin-bottom:15px;overflow:visible;overflow:initial;padding-bottom:0}.districts-block .district[data-v-52df91b0]{width:25%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
